import React, { useEffect } from 'react';

function FinanceMagazine() {
  useEffect(() => {
    const carousel = document.getElementById('magazine-carousel');

    window.scrollCarousel = function (direction) {
      if (carousel) {
        const scrollAmount = 300;
        carousel.scrollBy({ left: scrollAmount * direction, behavior: 'smooth' });
      }
    };

    // Optional: Cleanup global if needed
    return () => {
      delete window.scrollCarousel;
    };
  }, []);

  return (
    <section id="finance-magazine" aria-labelledby="finance-magazine-label">
      <div className="magazine-header revealable">
        <h2 id="finance-magazine-label">Finance Magazine</h2>
        <p>
          Applied financial analysis and market research designed to support valuation, strategy, and investment decisions.
        </p>
      </div>

      <div className="featured-insights revealable">
        <h3>Featured Insights</h3>

        <div className="featured-grid">

          <a href="/assets/magazine/grain-deal-expiration-event-study.pdf" target="_blank" className="featured-item">
            <img src="assets/grain-deal-thumb.png" alt="Grain Deal Expiration: Event Study" />
            <h4>Grain Deal Expiration: Event Study</h4>
          </a>

          <a href="/assets/magazine/apple-valuation-breakdown.pdf" target="_blank" className="featured-item">
            <img src="assets/apple-valuation-thumb.png" alt="Apple Inc. Valuation Breakdown" />
            <h4>Apple Inc. Valuation Breakdown</h4>
          </a>

          <a href="/assets/magazine/faang-vs-sp500-performance.pdf" target="_blank" className="featured-item">
            <img src="assets/faang-sp500-thumb.png" alt="FAANG Portfolio vs S&P 500" />
            <h4>FAANG Portfolio vs S&P 500</h4>
          </a>

          <a href="/assets/magazine/q2-banking-sector-earnings.pdf" target="_blank" className="featured-item">
            <img src="assets/q2-banking-thumb.png" alt="Q2 Earnings & Banking Sector Outlook" />
            <h4>Q2 Earnings & Banking Sector Outlook</h4>
          </a>

          <a href="/assets/magazine/faang-risk-top-ai-stocks.pdf" target="_blank" className="featured-item">
            <img src="assets/faang-ai-thumb.png" alt="FAANG Risk & Top AI Stocks" />
            <h4>FAANG Risk & Top AI Stocks</h4>
          </a>

        </div>
      </div>
      <h3 className="all-articles-title">All Articles</h3>
      <div className="carousel-wrapper revealable">
        <button className="carousel-btn left" onClick={() => window.scrollCarousel(-1)}>‹</button>

        <div className="carousel-track" id="magazine-carousel">
        <article>
          <h4>Trump Savings Account vs Roth IRA vs 529 Plans</h4>
          <p>
            A comprehensive comparative analysis of three major tax-advantaged accounts — including full appendices
            on investment growth, monthly contributions, and capped limits over 30 years.
          </p>
          <a
            href="/assets/magazine/trump-roth-ira-529-comparison.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read More
          </a>
        </article>

        <article>
          <h4>Where to Invest SAR 10,000 Now</h4>
          <p>
            A global perspective on strategic investments — from European pharma to Japanese real estate — in the face of market volatility. Practical insights to guide your next financial move.
          </p>
          <a
            href="/assets/magazine/where-to-invest-sar-10000.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read More
          </a>
        </article>

        <article>
          <h4>Stakeholder Influence & Market Manipulation</h4>
          <p>
            From the 1929 crash to modern financial oversight, this article examines how powerful stakeholders affect market outcomes — and how regulators work to ensure fair play.
          </p>
          <a
            href="/assets/magazine/stakeholder-influence-market-manipulation.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read More
          </a>
        </article>

        <article>
          <h4>Forecasting Financial Data with Facebook Prophet</h4>
          <p>
            Learn how to predict stock trends using Facebook Prophet in Google Colab. A practical guide to integrating predictive analytics into investment analysis.
          </p>
          <a
            href="/assets/magazine/forecasting-data-facebook-prophet.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read More
          </a>
        </article>

        <article>
          <h4>Hacking the Human: AI, Trust & Behaviour</h4>
          <p>
            Explore how data collection, AI algorithms, and biometrics are reshaping human trust, cognition, and behaviour in the digital age.
          </p>
          <a
            href="/assets/magazine/ai-trust-human-behavior.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read More
          </a>
        </article>

        <article>
          <h4>Dividend Kings 2023: Resilient & Rewarding Investments</h4>
          <p>
            Discover elite companies that have delivered decades of consistent dividend payouts — a blueprint for stability, growth, and long-term returns.
          </p>
          <a
            href="/assets/magazine/dividend-kings-2023.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read More
          </a>
        </article>
        <article>
          <h4>Understanding Option Greek: Delta</h4>
          <p>
            Learn what Delta is, why it matters in options trading, and how to calculate and apply it to refine your investment strategies.
          </p>
          <a
            href="/assets/magazine/option-greek-delta-guide.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read More
          </a>
        </article>

        <article>
          <h4>MSM30 Index: 1-Year Market Review</h4>
          <p>
            A deep dive into the MSM30 Index’s price trends, trading volumes, and forecasts. Uncover insights shaping Oman's stock market outlook.
          </p>
          <a
            href="/assets/magazine/msm30-index-market-review.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read More
          </a>
        </article>

        <article>
          <h4>Oman Capital Markets: Trends & Outlook</h4>
          <p>
            Discover the evolution of Oman's capital market — from MSX performance to Vision 2040 initiatives — and explore what’s driving future growth.
          </p>
          <a
            href="/assets/magazine/oman-capital-markets-trends.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read More
          </a>
        </article>

        <article>
          <h4>How Rising Rates Hit Tech Stocks</h4>
          <p>
            Explore the impact of interest rate hikes on tech giants and the QQQ ETF, with performance breakdowns and analysis across multiple timeframes.
          </p>
          <a
            href="/assets/magazine/rising-interest-rates-tech-stocks.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read More
          </a>
        </article>

        <article>
          <h4>Top Trading Platforms of 2023</h4>
          <p>
            A detailed review of the top 24 online brokerages this year — from Interactive Brokers to Webull — plus strategic advice for smarter investing.
          </p>
          <a
            href="/assets/magazine/top-trading-platforms-2023.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read More
          </a>
        </article>

        <article>
          <h4>ExxonMobil: Growth & ESG Outlook</h4>
          <p>
            A full financial and ESG analysis of ExxonMobil, with price targets, market performance, and portfolio diversification tips for savvy investors.
          </p>
          <a
            href="/assets/magazine/exxonmobil-growth-esg-outlook.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read More
          </a>
        </article>

        <article>
          <h4>Meta vs. Netflix: Liquidity Analysis</h4>
          <p>
            A deep dive into the liquidity, volatility, and market performance of Meta and Netflix — with insights on VAR, turnover, and historical trends.
          </p>
          <a
            href="/assets/magazine/meta-netflix-liquidity-analysis.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read More
          </a>
        </article>

        <article>
          <h4>Decoding FAANG’s Financial Performance</h4>
          <p>
            A 4-year deep dive into profitability, liquidity, and solvency ratios of Apple, Meta, Google, Amazon, and Netflix — revealing key strengths and risks.
          </p>
          <a href="/assets/magazine/faang-financial-performance.pdf" target="_blank" rel="noopener noreferrer">Read More</a>
        </article>

        <article>
          <h4>FAANG Valuation & Risk Assessment</h4>
          <p>
            Comprehensive analysis of valuation metrics, risks, and competitive positioning of Facebook, Amazon, Apple, Netflix, and Google.
          </p>
          <a href="/assets/magazine/faang-valuation-risk-assessment.pdf" target="_blank" rel="noopener noreferrer">Read More</a>
        </article>

        <article>
          <h4>Top Tech Stocks to Watch in 2H2023</h4>
          <p>
            Explore three tech stocks with strong growth, solid fundamentals, and positive market sentiment to ride the FAANG-led tech revolution.
          </p>
          <a href="/assets/magazine/top-tech-stocks-2h2023.pdf" target="_blank" rel="noopener noreferrer">Read More</a>
        </article>

        <article>
          <h4>An Outline of Basic Trading</h4>
          <p>
            A practical guide covering technical analysis, bullish & bearish candlesticks, indicators, and fundamental analysis to navigate financial markets.
          </p>
          <a href="/assets/magazine/basic-trading-outline.pdf" target="_blank" rel="noopener noreferrer">Read More</a>
        </article>

        <article>
          <h4>Understanding Fluctuations in Economic Indicators</h4>
          <p>
            Explore key graphs and charts revealing trends and patterns shaping the global economy’s dynamic financial landscape.
          </p>
          <a href="/assets/magazine/economic-indicators-fluctuations.pdf" target="_blank" rel="noopener noreferrer">Read More</a>
        </article>

        <article>
          <h4>Inflation & Consumer Expectations in G7 Economies</h4>
          <p>
            An insightful analysis of consumer prices, inflation rates, and expectations across G7 countries, with a focus on the US.
          </p>
          <a href="/assets/magazine/g7-inflation-consumer-expectations.pdf" target="_blank" rel="noopener noreferrer">Read More</a>
        </article>

        <article>
          <h4>Unlocking Data Potential in Aviation</h4>
          <p>
            Explore how data interpretation and strategic analysis can drive business growth in the aviation industry.
          </p>
          <a href="/assets/magazine/data-potential-aviation.pdf" target="_blank" rel="noopener noreferrer">Read More</a>
        </article>

        <article>
          <h4>Financial Glossary for Beginners</h4>
          <p>
            A. Alamoudi's beginner-friendly glossary breaking down financial terms to help users build confidence and navigate finance.
          </p>
          <a href="/assets/magazine/financial-glossary-beginners.pdf" target="_blank" rel="noopener noreferrer">Read the Glossary</a>
        </article>

        <article>
          <h4>Berkshire Hathaway Investment Portfolio Highlights</h4>
          <p>
            A snapshot of Berkshire Hathaway's $299 billion portfolio (Feb 2023), spotlighting major stakes and diversification strategy.
          </p>
          <a href="/assets/magazine/berkshire-hathaway-portfolio-2023.pdf" target="_blank" rel="noopener noreferrer">Read the Portfolio</a>
        </article>

        <article>
          <h4>Fintech and Innovation: Neobank</h4>
          <p>
            A RES4U report on neobank challenges and regulatory gaps, featuring the Xinja case study in Malaysia.
          </p>
          <a href="/assets/magazine/neobank-fintech-innovation-res4u.pdf" target="_blank" rel="noopener noreferrer">Read the Full Report</a>
        </article>

        <article>
          <h4>Blockchain Economics: Sustainability and Circular Economy</h4>
          <p>
            Exploring how blockchain powered traceability in supply chains — with a focus on sustainability and circular business models.
          </p>
          <a href="/assets/magazine/blockchain-sustainability-circular-economy.pdf" target="_blank" rel="noopener noreferrer">Read the Full Report</a>
        </article>

        <article>
          <h4>PM Resignation & Impact on Takaful and Insurance</h4>
          <p>
            An event-study exploring the resignation's effect on stock returns and volatility in Malaysia’s insurance sector.
          </p>
          <a href="/assets/magazine/pm-resignation-takaful-insurance.pdf" target="_blank" rel="noopener noreferrer">Read the Full Study</a>
        </article>

        <article>
          <h4>Low Interest Rate Impacts on Islamic & Conventional Banks</h4>
          <p>
            A cross-bank study on how low rates affect financial performance across Islamic and conventional institutions.
          </p>
          <a href="/assets/magazine/low-interest-rate-islamic-banks.pdf" target="_blank" rel="noopener noreferrer">Read the Full Report</a>
        </article>

        <article>
          <h4>UK Budget Response & Monetary Policy Amid COVID-19</h4>
          <p>
            Overview of the UK’s £30bn response to COVID-19, including monetary stimulus, tax breaks, and public sector investment.
          </p>
          <a href="/assets/magazine/uk-budget-covid-monetary-policy.pdf" target="_blank" rel="noopener noreferrer">Read More</a>
        </article>
        </div>

        <button className="carousel-btn right" onClick={() => window.scrollCarousel(1)}>›</button>
      </div>
    </section>
  );
}

export default FinanceMagazine;